{
  "title": "Citas",
  "description": "Ver y gestionar sus citas",
  "searchPlaceholder": "Buscar citas...",
  "emptyTitle": "Aún no hay citas",
  "emptyDescription": "Aún no ha recibido ninguna cita. Cuando los clientes reserven sus servicios, aparecerán aquí.",
  "viewDetails": "Ver detalles",
  "columns": {
    "customer": "Cliente",
    "service": "Servicio",
    "date": "Fecha",
    "time": "Hora",
    "status": "Estado",
    "booking": "Reserva"
  },
  "status": {
    "all": "Todos",
    "pending": "Pendiente",
    "active": "Activa",
    "inProgress": "En curso",
    "completed": "Completada",
    "cancelled": "Cancelada",
    "expired": "Expirada",
    "rescheduleRequested": "Reprogramación solicitada",
    "approved": "Aprobada",
    "rejected": "Rechazada",
    "reported": "Reportada"
  },
  "show": {
    "title": "Detalles de la cita",
    "documentTitle": "Cita de {{name}}",
    "documentTitleFallback": "Detalles de la cita",
    "description": "Ver información de la cita para {{service}}",
    "thisService": "este servicio",
    "actions": "Acciones",
    "requestReschedule": "Solicitar reprogramación",
    "sendingRequest": "Enviando solicitud...",
    "notFoundTitle": "Cita no encontrada",
    "notFoundDescription": "No se pudo encontrar la cita que busca.",
    "loadFailed": "Error al cargar la cita",
    "backToAppointments": "Volver a citas",
    "date": "Fecha",
    "time": "Hora",
    "serviceInformation": "Información del servicio",
    "serviceName": "Nombre del servicio",
    "unit": "Unidad",
    "rating": "Calificación",
    "customer": "Cliente",
    "serviceProvider": "Proveedor de servicio",
    "noEmail": "Sin correo electrónico",
    "quickActions": "Acciones rápidas",
    "emailCustomer": "Enviar correo al cliente",
    "idNotFound": "ID de cita no encontrado",
    "rescheduleSuccess": "Solicitud de reprogramación enviada correctamente",
    "rescheduleFailed": "Error al reprogramar la cita",
    "markInProgress": "Marcar en curso",
    "markingInProgress": "Marcando en curso...",
    "inProgressSuccess": "Cita marcada en curso",
    "inProgressFailed": "Error al marcar la cita en curso",
    "complete": "Marcar completada",
    "completing": "Completando...",
    "completeSuccess": "Cita marcada como completada",
    "completeFailed": "Error al completar la cita",
    "cancelAppointment": "Cancelar cita",
    "cancelling": "Cancelando...",
    "cancelSuccess": "Cita cancelada",
    "cancelFailed": "Error al cancelar la cita",
    "acceptReschedule": "Aceptar reprogramación",
    "acceptingReschedule": "Aceptando...",
    "acceptRescheduleSuccess": "Reprogramación aceptada",
    "acceptRescheduleFailed": "Error al aceptar la reprogramación",
    "rejectReschedule": "Rechazar solicitud de reprogramación",
    "rejectingReschedule": "Rechazando...",
    "rejectRescheduleSuccess": "Solicitud de reprogramación rechazada",
    "rejectRescheduleFailed": "Error al rechazar la solicitud",
    "initiateAdditionalFee": "Solicitar cargo adicional",
    "initiateAdditionalFeeDescription": "Solicite un pago adicional al cliente por esta cita.",
    "feeAmount": "Importe",
    "feeAmountInvalid": "Introduzca un importe válido mayor que cero",
    "initiateFee": "Enviar solicitud",
    "initiatingFee": "Enviando...",
    "feeInitiatedSuccess": "Solicitud de cargo adicional enviada",
    "feeInitiatedFailed": "Error al solicitar cargo adicional",
    "notes": "Notas",
    "notePlaceholder": "Añada una nota sobre esta cita...",
    "addNote": "Añadir nota",
    "addingNote": "Añadiendo...",
    "noteRequired": "Introduzca una nota antes de guardar",
    "noteAddedSuccess": "Nota añadida",
    "noteAddedFailed": "Error al añadir la nota",
    "notesLoadFailed": "Error al cargar las notas",
    "noNotes": "Aún no hay notas",
    "reschedulePendingHint": "Esperando que el cliente acepte la reprogramación propuesta."
  },
  "bookAppointment": "Reservar cita",
  "bookForCustomer": "Reservar para este cliente",
  "booking": {
    "title": "Reservar cita",
    "adminTitle": "Reservar cita (admin)",
    "description": "Crear una cita en nombre de un cliente.",
    "adminDescription": "Seleccione un negocio y reserve una cita para uno de sus clientes.",
    "success": "Cita reservada correctamente",
    "loadingSlots": "Cargando horarios disponibles...",
    "noSlots": "No hay horarios disponibles para esta fecha.",
    "freeServiceHint": "Este servicio es gratuito — no se requiere pago.",
    "customer": {
      "createNew": "Nuevo cliente",
      "searchExisting": "Cliente existente"
    },
    "steps": {
      "customer": { "title": "Cliente", "description": "Buscar o crear el cliente." },
      "service": { "title": "Servicio", "description": "Elegir servicio y proveedor." },
      "schedule": { "title": "Fecha y hora", "description": "Elegir un horario disponible." },
      "payment": { "title": "Pago", "description": "Elegir cómo se paga la reserva." },
      "confirm": { "title": "Confirmar", "description": "Revisar y enviar." }
    },
    "fields": {
      "business": "Negocio",
      "customerName": "Nombre del cliente",
      "customerEmail": "Correo",
      "customerPhone": "Teléfono",
      "customerSearch": "Buscar clientes",
      "customerSearchPlaceholder": "Buscar por nombre, correo o teléfono",
      "customerSelectPlaceholder": "Seleccionar un cliente",
      "service": "Servicio",
      "servicePlaceholder": "Seleccionar un servicio",
      "provider": "Proveedor (opcional)",
      "providerPlaceholder": "Cualquier proveedor disponible",
      "date": "Fecha",
      "timeSlot": "Horario",
      "paymentMode": "Modo de pago",
      "momoNumber": "Número de mobile money",
      "momoNetwork": "Red (MTN, Vodafone, etc.)",
      "paymentMethodId": "ID de método de pago guardado",
      "paymentMethodIdPlaceholder": "ID de tarjeta o MoMo guardado del cliente",
      "paymentMethodIdHint": "Use un ID de método guardado en lugar de MoMo, o deje en blanco para cobrar al número anterior.",
      "staffNotes": "Notas del personal",
      "staffNotesPlaceholder": "Notas de recepción (opcional)"
    },
    "paymentModes": {
      "offline": "Efectivo / offline",
      "payment_link": "Enviar enlace de pago",
      "staff_online": "MoMo ingresado por personal"
    },
    "actions": {
      "back": "Atrás",
      "next": "Siguiente",
      "confirm": "Confirmar reserva",
      "submitting": "Reservando..."
    },
    "errors": {
      "businessRequired": "Seleccione un negocio primero",
      "customerRequired": "No se pudo resolver el cliente",
      "slotRequired": "Seleccione un horario",
      "loadSlots": "No se pudieron cargar los horarios",
      "submit": "No se pudo completar la reserva"
    },
    "audit": {
      "bookedBy": "Reservado por {{name}}",
      "sourceConsole": "Consola del personal",
      "sourceProvider": "App del proveedor",
      "sourceAdmin": "Admin de plataforma",
      "sourceCustomer": "App del cliente",
      "sourceUnknown": "Reserva del personal",
      "paymentUnknown": "Pago del personal",
      "sourceConsoleShort": "Consola",
      "sourceProviderShort": "App proveedor",
      "sourceAdminShort": "Admin",
      "staffBooked": "Reserva staff"
    },
    "intake": {
      "title": "Preguntas de admisión",
      "description": "Responda las preguntas requeridas para este servicio.",
      "required": "Esta pregunta es obligatoria"
    }
  }
}
